import { BasicIndex, createCollection } from '@tanstack/db';
import { queryCollectionOptions } from '@tanstack/query-db-collection';

import { getDynMetaVoorschriftLabel } from '@/api/generated/digiVAPI';
import { queryClient } from '@/services/queryClient';
import { fetchAllPages } from '@/utils/fetchAllPages';

export type VoorschriftLabelCollection = ReturnType<
  typeof createVoorschriftLabelCollection
>;
type VoorschriftLabelCollections = Record<string, VoorschriftLabelCollection>;

const voorschriftLabelCollections: VoorschriftLabelCollections = {};

export const getVoorschriftLabelCollection = ({
  besluitLineageId,
}: {
  besluitLineageId: string;
}) => {
  const collection = voorschriftLabelCollections[besluitLineageId];

  if (collection) return collection;

  const newCollection = createVoorschriftLabelCollection({ besluitLineageId });

  voorschriftLabelCollections[besluitLineageId] = newCollection;

  return newCollection;
};

const createVoorschriftLabelCollection = ({
  besluitLineageId,
}: {
  besluitLineageId: string;
}) => {
  const collection = createCollection(
    queryCollectionOptions({
      id: `voorschrift-label-collection-${besluitLineageId}`,
      queryClient,
      defaultIndexType: BasicIndex,
      queryKey: ['voorschrift-label-collection', besluitLineageId],
      getKey: (item) => item.ID,
      queryFn: async () => {
        const response = await fetchAllPages((page) =>
          getDynMetaVoorschriftLabel({
            page,
            size: 100,
            filter: [
              {
                model: 'VoorschriftLineage',
                field: 'Besluit_lineage',
                op: 'eq',
                value: besluitLineageId,
              },
            ],
          })
        );

        return response;
      },
    })
  );

  collection.createIndex((item) => item.Voorschrift_lineage);

  return collection;
};
